import { BriefCommercialEvaluation } from '@src/main/modules/reports/shared/domain/evaluation.interface';
import { TFunction } from 'i18next';
import { Button } from 'primereact/button';
import { useCallback } from 'react';

export const useCommercialEvaluationColumnBodies = (
  t: TFunction,
  downloadPdf: (evaluation: BriefCommercialEvaluation) => void,
  handleDeleteEvaluation: (evaluation: BriefCommercialEvaluation) => void,
) => {
  const pdfColumnBody = useCallback(
    (rowData: BriefCommercialEvaluation) => (
      <Button
        icon="pi pi-paperclip"
        className="p-button-text"
        tooltip={t('common.download')}
        onClick={() => downloadPdf(rowData)}
        pt={{ icon: { style: { color: 'var(--primary-color)' } } }}
      />
    ),
    [downloadPdf, t],
  );

  const deleteColumnBody = useCallback(
    (rowData: BriefCommercialEvaluation) => (
      <Button
        icon="pi pi-trash"
        className="p-button-text p-button-danger"
        tooltip={t('common.delete')}
        onClick={() => handleDeleteEvaluation(rowData)}
      />
    ),
    [handleDeleteEvaluation, t],
  );

  return { pdfColumnBody, deleteColumnBody };
};
